<template>
  <div>
    <h5 class="py-5 mb-3">
      {{ $t("personal.essential") }}
    </h5>
    <v-form>
      <!--<v-row>
        <v-col cols="12" md="2" class="pl-0 pl-lg-6">
          <v-subheader>
            <span>{{ $t("form.titulacion") }}</span>
          </v-subheader>
        </v-col>
        <v-col cols="12" md="9">
          <v-text-field
            v-model="investigator.publicProfile.title"
            class="mr-2"
            required
            outlined
            hide-details
          ></v-text-field>
        </v-col>
      </v-row>-->
      <v-row>
        <v-col cols="12" md="11" class="pl-0 pl-lg-6">
          <MultilingualTextField
            class="mr-2"
            :value="investigator.publicProfile.text_website"
            :label="$t('form.biography')"
            :rich="true"
            entity-type="publicProfile"
            field="text_website"
            @input="updateBiography"
          />
        </v-col>
      </v-row>
      <h5 class="py-5 mb-3">
        {{ $t("personal.optional_some_apps") }}
      </h5>
      <v-row>
        <v-col cols="12" md="2" class="pl-0 pl-lg-6">
          <v-subheader>
            <span>{{ $t("form.picture_portrait") }}</span>
          </v-subheader>
        </v-col>
        <v-col cols="12" md="9">
          <UploadImage
            :path="
              this.$store.state.endpoint +
                '/publicProfile/' +
                this.getUser.person
            "
            :url="
              this.$store.state.endpoint +
                this.investigator.publicProfile.picture_portrait
            "
            :object="{ name: this.investigator.publicProfile.picture_portrait }"
            :object_created="true"
            name_field="picture_portrait"
          />
          <div class="caption grey--text text--darken-1 mt-1">
            {{ $t("form.picture_portrait_help") }}
          </div>
        </v-col>
      </v-row>
    </v-form>
    <v-form>
      <v-row>
        <v-col cols="12" sm="3" lg="2" class="py-0 pl-0 pl-lg-6">
          <v-subheader class="mt-3">
            <span>{{ $t("form.birthdate") }}</span>
          </v-subheader>
        </v-col>
        <v-col cols="12" sm="5" lg="4" class="without-padding-left">
          <v-menu
            v-model="menu"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                v-model="investigator.publicProfile.birthdate"
                :label="$t('form.birthdate')"
                prepend-inner-icon="event"
                readonly
                clearable
                outlined
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="investigator.publicProfile.birthdate"
              @input="menu = false"
              :max="maxBirthdayDate"
              min="1950-01-01"
              ref="birthdatePicker"
            >
            </v-date-picker>
          </v-menu>
        </v-col>
      <v-col cols="12" sm="3" offset-sm="1" lg="1" offset-lg="4" class="d-flex justify-start pt-0 mt-0">
        <v-checkbox
                class="my-auto"
          :label="$t('form.public')"
          v-model="investigator.publicProfile.public_birthdate"
          dense
        />
      </v-col>
    </v-row>
    <h5 class="py-5 mb-3">
        {{ $t("personal.os_pincode_title") }}
      </h5>
    <v-row>
      <v-col cols="12" md="2" class="pl-0 pl-lg-6">
        <v-subheader class="mt-3 d-flex align-center">
          <span>{{ $t("personal.os_pincode_title") }}</span>
          <v-btn
            icon
            x-small
            class="ml-2"
            @click="showPinInfo = true"
            :aria-label="$t('personal.os_pincode_more_info')"
          >
            <v-icon small>mdi-information</v-icon>
          </v-btn>
        </v-subheader>
      </v-col>
      <v-col cols="12" md="4" class="without-padding-left">
        <v-text-field
          v-model="investigator.publicProfile.os_pincode"
          name="ubuntu-pin"
          autocomplete="off"
          inputmode="numeric"
          :append-icon="showOsPincode ? 'mdi-eye' : 'mdi-eye-off'"
          :label="$t('form.os_pincode')"
          :type="showOsPincode ? 'text' : 'password'"
          @click:append="showOsPincode = !showOsPincode"
          outlined
          maxlength="6"
          :rules="rules.osPincodeRules"
          :hint="$t('form.os_pincode_help')"
          persistent-hint
        />
      </v-col>
    </v-row>
    <v-dialog
      v-model="showPinInfo"
      max-width="600"
    >
      <v-card>
        <v-card-title class="headline">
          {{ $t("personal.os_pincode_modal_title") }}
        </v-card-title>
        <v-card-text>
          <p>{{ $t("personal.os_pincode_modal_usage") }}</p>
          <p>{{ $t("personal.os_pincode_modal_empty") }}</p>
          <p>{{ $t("personal.os_pincode_modal_warning") }}</p>
          <p>{{ $t("personal.os_pincode_modal_keyring") }}</p>
        </v-card-text>
        <v-card-actions class="justify-end">
          <v-btn text color="primary" @click="showPinInfo = false">
            {{ $t("button.close") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-form>

    <h5 class="py-5 mb-3">
      {{ $t("personal.scientific_accounts") }}
    </h5>
    <v-form>
      <v-row v-for="profile in academiaProfiles" :key="profile.title">
        <v-col cols="12" lg="2" class="py-0 pl-0 pl-lg-6">
          <v-subheader>
            <span>{{ profile.title }}</span>
          </v-subheader>
        </v-col>
        <v-col
          cols="12"
          lg="10"
          class="without-padding-left"
        >
          <v-text-field
            v-model="investigator.publicProfile.academia_profile[profile.model].value"
            required
            dense
            outlined
            hide-details
            :placeholder="profile.label"
            :prefix="profile.prefix"
          >
            <template v-slot:append>
              <v-checkbox
                :label="$t('form.public')"
                v-model="investigator.publicProfile.academia_profile[profile.model].public"
                dense
                class="ma-0 pa-0"
              />  
            </template>
          </v-text-field>
        </v-col>
      </v-row>

      <h5 class="py-5 mb-3">
      {{ $t("personal.social_accounts") }}
      </h5>

      <v-row v-for="profile in socialProfiles" :key="profile.title">
        <v-col cols="12" lg="2" class="py-3 pl-0 pl-lg-6">
          <v-subheader>
            <span>{{ profile.title }}</span>
          </v-subheader>
        </v-col>
        <v-col
          cols="12"
          lg="10"
          class="without-padding-left"
        >
          <v-text-field
            v-model="
              investigator.publicProfile.social_profile[profile.model].value
            "
            required
            outlined
            dense
            hide-details
            :placeholder="profile.label"
            :prefix="profile.prefix"
          >
            <template v-slot:append>
              <v-checkbox
                :label="$t('form.public')"
                v-model="investigator.publicProfile.social_profile[profile.model].public"
                dense
                class="ma-0 pa-0"
              />  
            </template>
          </v-text-field>
        </v-col>
      </v-row>

      <h5 class="py-5 mb-3">
       {{ $t("personal.ssh_keys") }}
      </h5>

      <ArrayFieldForm
        v-model="investigator.publicProfile.pubkey"
        name-field="pubkey"
        :placeholder="$t('form.pubkeys')"
      />

    </v-form>


    <v-row class="mt-6">
      <v-col cols="12" class="text-center">
        <v-btn @click="cancel" class="mr-4">{{ $t("button.back") }}</v-btn>
        <v-btn color="primary" class="mr-4" @click="submit">{{
          $t("button.save")
        }}</v-btn>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import MultilingualTextField from "../reusables/MultilingualTextField.vue";
import UploadImage from "../layouts/UploadImage";
import ArrayFieldForm from "../../components/reusables/ArrayFieldForm";
import axios from "axios";
import validationRules from "../../mixins/validationRules";
export default {
  mixins: [validationRules],
  components: {
    MultilingualTextField,
    ArrayFieldForm,
    UploadImage
  },

  data() {
    return {
      menu: false,
      maxBirthdayDate: null,
      showPinInfo: false,
      investigator: {
        publicProfile: {
          title: "",
          picture_portrait: "",
          birthdate: "",
          public_birthdate: false,
          academia_profile: {
            orcid_id: {
              value: "",
              public: false
            },
            researcher_id: {
              value: "",
              public: false
            },
            scopus_author_id: {
              value: "",
              public: false
            },
            google_scholar: {
              value: "",
              public: false
            }
          },
          social_profile: {
            twitter: {
              value: "",
              public: false
            },
            bluesky: {
              value: "",
              public: false
            },
            youtube: {
              value: "",
              public: false
            },
            threads: {
              value: "",
              public: false
            },
            wechat: {
              value: "",
              public: false
            },
            facebook: {
              value: "",
              public: false
            },
            linkedin: {
              value: "",
              public: false
            },
            telegram: {
              value: "",
              public: false
            },
            github: {
              value: "",
              public: false
            },
            tiktok: {
              value: "",
              public: false
            },
            instagram: {
              value: "",
              public: false
            },
            pagina_personal: {
              value: "",
              public: false
            }
          },
          os_pincode: "",
          text_website: {
            es: "",
            en: "",
            gl: ""
          },
          pubkey: [""]
        }
      },

      academiaProfiles: [
        {
          title: "Orcid id",
          model: "orcid_id",
          prefix: "https://orcid.org/",
          label: "0000-0000-0000-0000"
        },
        {
          title: "Researcher ID",
          model: "researcher_id",
          prefix: "https://www.researcherid.com/rid/",
          label: "A-0000-0000"
        },
        {
          title: "Scopus Author ID",
          model: "scopus_author_id",
          prefix: "https://scopus.com/authid/detail.url?authorId=",
          label: "00000000000"
        },
        {
          title: "Google Scholar",
          model: "google_scholar",
          prefix: "https://scholar.google.es/citations?user=",
          label: "x0xxxxAAAAAJ"
        }
      ],
      socialProfiles: [
        {
          title: "X",
          model: "twitter",
          prefix: "https://x.com/",
          label: "username"
        },
        {
          title: "BlueSky",
          model: "bluesky",
          prefix: "https://bsky.app/profile/",
          label: "handle",
        },
        {
          title: "Youtube",
          model: "youtube",
          prefix: "https://youtube.com/@",
          label: "handle"
        },
        {
          title: "Threads",
          model: "threads",
          prefix: "https://threads.net/@",
          label: "handle"
        },
        {
          title: "Facebook",
          model: "facebook",
          prefix: "https://www.facebook.com/",
          label: "username"
        },
        {
          title: "Instagram",
          model: "instagram",
          prefix: "https://www.instagram.com/",
          label: "username"
        },
        {
          title: "TikTok",
          model: "tiktok",
          prefix: "https://www.tiktok.com/@",
          label: "username"
        },
        {
          title: "Linkedin",
          model: "linkedin",
          prefix: "https://es.linkedin.com/in/",
          label: "username"
        },
        {
          title: "Telegram",
          model: "telegram",
          prefix: "https://t.me/",
          label: "username"
        },
        {
          title: "Github",
          model: "github",
          prefix: "https://github.com/",
          label: "username"
        },
        {
          title: "Página personal",
          model: "pagina_personal",
          prefix: "https://",
          label: "www.yourwebsite.com/"
        }
      ],
      showOsPincode: false
    };
  },

  watch: {
    menu(val) {
      val &&
        this.$nextTick(
          () => (this.$refs.birthdatePicker.activePicker = "YEAR")
        );
    }
  },

  methods: {
    getPublicProfile() {
      const path =
        this.$store.state.endpoint + "/publicProfile/" + this.getUser.person;
      axios
        .get(path)
        .then(response => {
          this.investigator.publicProfile = response.data;
          if (
            this.investigator.publicProfile.os_pincode === undefined ||
            this.investigator.publicProfile.os_pincode === null
          ) {
            this.investigator.publicProfile.os_pincode = "";
          }
          if (this.investigator.publicProfile.pubkey.length === 0) {
            this.investigator.publicProfile.pubkey = [""];
          }
          this.socialProfiles.forEach(socialProfile => {
            const containsKey = (obj, key) =>
              Object.keys(response.data.social_profile).includes(
                socialProfile.model
              );
            if (containsKey()) {
              this.investigator.publicProfile.social_profile[socialProfile.model] = response.data.social_profile[socialProfile.model];
            }
            else{
              this.investigator.publicProfile.social_profile[socialProfile.model] = {value:"", public: false}
            }
          });
          this.academiaProfiles.forEach(academiaProfile => {
            const containsKey = (obj, key) =>
              Object.keys(response.data.academia_profile).includes(
                academiaProfile.model
              );
            if (containsKey()) {
              this.investigator.publicProfile.academia_profile[academiaProfile.model] = response.data.academia_profile[academiaProfile.model];
            }
            else{
              this.investigator.publicProfile.academia_profile[academiaProfile.model] = {value:"", public: false}
            }
          });
        })
        .catch(error => {
          console.log(error);
        });
    },
    submit() {
      delete this.investigator.publicProfile.picture_portrait;
      let path =
        this.$store.state.endpoint + "/publicProfile/" + this.getUser.person;
      axios
        .patch(path, this.investigator.publicProfile)
        .then(response => {
          this.$store.commit("alert", {
            color: "success",
            text: this.$t("forms.updatePublicData")
          });
        })
        .catch(error => {
          console.log(error);
          console.log(error.response ? error.response.data : null);
          const serverMessage = this.getServerErrorMessage(error);
          this.$store.commit("alert", {
            color: "error",
            text:
              serverMessage ||
              this.$t("error.saving", [this.$t("public_data")])
          });
        });
    },
    cancel() {
      this.$router.go(-1);
    },

    updateBiography(value) {
      this.investigator.publicProfile.text_website = value;
    },

    loadBirthdayDate() {
      let date = new Date();
      date.setFullYear(date.getFullYear() - 15);
      this.maxBirthdayDate = date.toISOString().substr(0, 10);
    },
    getServerErrorMessage(error) {
      const data = error && error.response ? error.response.data : null;
      if (!data) {
        return "";
      }
      if (typeof data === "string") {
        return data;
      }
      if (Array.isArray(data)) {
        return data.join(", ");
      }
      if (typeof data === "object") {
        const firstKey = Object.keys(data)[0];
        if (!firstKey) {
          return "";
        }
        const value = data[firstKey];
        if (Array.isArray(value)) {
          return `${firstKey}: ${value.join(", ")}`;
        }
        if (typeof value === "string") {
          return `${firstKey}: ${value}`;
        }
      }
      return "";
    }
  },

  created() {
    this.loadBirthdayDate();
    this.getPublicProfile();
  }
};
</script>
